"use client";

import React, { useState } from "react";
import { useSnackbar } from "notistack";
import http from "@/libs/config/http";
import { PatternFormat } from "react-number-format";

const ContactForm = ({ t }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = "";

    if (!value.trim()) {
      error = t["empty.wrong"] || "Bu xana boş ola bilməz";
    } else {
      if (name === "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          error = t["email.wrong"] || "Email düzgün deyil";
        }
      }
      if (name === "phone") {
        const phoneRegex = /^\+?\d{7,15}$/;
        if (!phoneRegex.test(value)) {
          error = t["phone.wrong"] || "Telefon nömrəsi düzgün deyil";
        }
      }
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const validateForm = () => {
    let valid = true;
    Object.keys(formData).forEach((key) => {
      const isValid = validateField(key, formData[key]);
      if (!isValid) valid = false;
    });
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      enqueueSnackbar(t["input.wrong"] || "Xanaları düzgün doldurun", {
        variant: "error",
      });
      return;
    }

    try {
      const res = await http("form/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      enqueueSnackbar(res?.message || t["success.message"], {
        variant: res?.success ? "success" : "error",
      });

      if (res?.success) {
        setFormData({ full_name: "", email: "", phone: "", message: "" });
        setErrors({});
      }
    } catch (err) {
      enqueueSnackbar(err.message || t["error.title"], { variant: "error" });
    }
  };

  return (
    <div className="contactForm">
      <div className="subTitle">
        <span>{t["title_question_for_us"]}</span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="div">
          <div className="inputChild">
            <label for="">{t["forms.name_placeholer"]}</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              placeholder={t["forms.name_placeholer"]}
            />
            {errors.full_name && (
              <span className="errorText">{errors.full_name}</span>
            )}
          </div>
          <div className="inputChild">
            <label for="">{t["forms.emails"]}</label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t["forms.emails"]}
            />
            {errors.email && <span className="errorText">{errors.email}</span>}
          </div>
          <div className="inputChild">
            <label for="">{t["forms.numbers"]}</label>

            <PatternFormat
              format="## ### ## ##"
              allowEmptyFormatting
              mask="_"
              value={formData.phone}
              onValueChange={(values) =>
                setFormData((prev) => ({ ...prev, phone: values.value }))
              }
              placeholder="00 000 00 00"
              type="text"
            />
            {errors.phone && <span className="errorText">{errors.phone}</span>}
          </div>
        </div>
        <div className="div">
          <div className="inputChild">
            <label for="">{t["forms.message_placeholder"]}</label>

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={t["forms.message_placeholder"]}
            />
            {errors.message && (
              <span className="errorText">{errors.message}</span>
            )}
          </div>
          <button className="blackButton" type="submit">
            {t["buttons.send"]}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
